import { Flex, VStack, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { gql } from 'urql';

import { useTranslation } from '@/app/i18n/client';
import { StickyHeader } from '@/components/common/Layout/Header/StickyHeader';
import { NftItem } from '@/components/common/NftItem';
import { SkeletonNftItem } from '@/components/common/NftItem/SkeletonNftItem';
import { useMyNfts } from '@/components/pages/V2/MyNfts/useMyNfts';

gql`
  fragment MyNftsPageItem on NftObject {
    id
    contentUrl
    lot {
      product {
        name
        nameEn
        targetObject {
          ... on Contributor {
            company {
              name
              nameEn
            }
            prefecture
            prefectureEn
            plantCapacityNumber
            co2PowerPerUnit
            daylightHours
          }
        }
      }
    }
    yellNftSummary {
      yellCount
    }
  }
`;

gql`
  query myNfts {
    webMyNfts {
      ...MyNftsPageItem
    }
  }
`;

const MyNftsPage: FC = () => {
  const { myNfts } = useMyNfts();
  const { t } = useTranslation('common');
  return (
    <>
      <StickyHeader>
        <Flex w="full" justify="center" align="center">
          <Text
            fontWeight="medium"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            textAlign="center"
          >
            {t('environmental_contribution_card')}
          </Text>
        </Flex>
      </StickyHeader>
      <VStack spacing="16px" mt="16px" px="24px" pb="40px">
        {myNfts === undefined
          ? Array.from({ length: 3 }).map((_, i) => <SkeletonNftItem key={i} />)
          : myNfts?.map(({ id, ...nft }) => {
              return <NftItem key={id} {...nft} />;
            })}
      </VStack>
    </>
  );
};

export { MyNftsPage };
